import type React from "react";
import * as styles from "./Spinner.css";

export interface Props {
	size?: string; // e.g. "50px", "3rem", etc.
	color?: string; // e.g. "#3498db", "red", etc.
	borderWidth?: string;
	className?: string;
}

export default function Spinner({
	size = "50px",
	color = "#3498db",
	borderWidth = "4px",
	className,
}: Props) {
	return (
		<div className={`${className}`}>
			<div
				className={styles.loadingSpinner}
				style={
					{
						"--spinner-size": size,
						"--spinner-color": color,
						"--spinner-border-width": borderWidth,
					} as React.CSSProperties
				}
			/>
		</div>
	);
}
